<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row mt-2">
    <div class="col-12">
      <div class="row">
        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <h5 class="mb-0 text-primary"><i class="fas fa-chalkboard text-primary me-1"></i> Class</h5>
          </div>
          <hr />
          <div class="row g-3">
            <div class="col-md-6">
              <label for="inputName" class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <input type="text" class="form-control form-control-sm" v-model="Obj.name" />
            </div>
            <div class="col-md-6">
              <label class="form-label" for="inputGroupSelect01">Section<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <select v-model="Obj.section" class="form-select form-select-sm rounded cursor-pointer" role="button">
                <option selected=""></option>
                <option v-for="(item, index) in secList" :key="index" :value="item._id">
                  {{ item.Name }}
                </option>
              </select>
            </div>
             <div class="col-md-12 text-end mt-2">
            <button class="btn btn-sm btn-darknavy me-1" @click="save">
              <i class="fa fa-save"></i> Save
            </button>
            <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
          </div>
           <ul v-if="error1.length" class="text-danger ps-3">
              <li v-for="(err1, index) in error1" :key="index">{{ err1 }}</li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-12 table-responsive mt-2">
              <div class="progress mb-0 progress-sm" v-if="progress1 != 0">
                <div class="progress-bar" role="progressbar" :aria-valuenow="progress1" aria-valuemin="0" aria-valuemax="100"
                  :style="{ width: progress1 + '%' }"></div>
              </div>
              <DataTable v-if="progress1 == 0" :columns="columns" :rows="rows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="d-flex align-items-center">
            <h5 class="mb-0 text-primary" > <i class="fa fa-user  text-primary me-1"></i> Section</h5>
          </div>
          <hr />
          <div class="row g-3">
            <div class="col-md-6">
              <label for="inputName" class="form-label">Name<sup><span class="text-danger font-12">*</span></sup>
                :</label>
              <input type="text" class="form-control form-control-sm" v-model="secObj.Name" />
            </div>

            <div class="col-md-12 text-end text-md-center mt-2">
              <button class="btn btn-sm btn-darknavy me-1" @click="secSave">
                <i class="fa fa-save"></i> Save
              </button>
               <button type="button" class="btn btn-sm btn-soft-dark" @click="secreset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
            </div>
          </div>
          <ul v-if="errors.length" class="text-danger ps-3">
              <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
            </ul>
          <div class="row">
            <div class="col-md-12 table-responsive mt-2">
                <div class="progress mb-0 progress-sm" v-if="progress2 != 0">
                <div class="progress-bar" role="progressbar" :aria-valuenow="progress2" aria-valuemin="0" aria-valuemax="100"
                  :style="{ width: progress2 + '%' }"></div>
                </div>
              <DataTable v-if="progress2 == 0" :columns="seccolumns" :rows="secrows" :pageSize="10"   :actions="{ edit: handleEdit, delete: handleDelete }" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="delObj.record" @delRecord="delRecord" @closeModal="delObj.record = ''"></DelPopup>
  </template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
import { useStore } from 'vuex'
import { schoolStore } from '@/utils/schoolStore';
const { secList} = schoolStore();
const store = useStore()
 const Obj=ref( { name: "", section: "" });
  const secObj=ref({ Name: "" });
  const msgObj=ref({ msg: "", role: "", show: false });
  const delObj=ref({});
  const errors=ref({});
   const error1=ref({});
  const columns=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'name' },
  { label: 'Section', key: 'sectionName' }
]);
const seccolumns = ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Name', key: 'Name' },
]);

const progress1 = ref(0)
const progress2 = ref(0)
let progressInterval1 = null
let progressInterval2 = null

const rows=ref([])
const secrows = ref([])

const loadClassData = async () => {
  progress1.value = 1
  progressInterval1 = setInterval(() => {
    progress1.value += 1
    if (progress1.value >= 100) progress1.value = 0
  }, 100)
await api.get('/cls/all').then(clsList => {
  rows.value = clsList.data .slice() .sort((a, b) => a.name.localeCompare(b.name)) .map((item, i) => {
      const section = secList.value.find(i => i._id == item.section);
      return {
        ...item,
        sectionName: section ? section.Name : '', 
        Sno: i + 1,
        record: 'cls'
      }
    });
  store.commit('setClasses', clsList.data)
  progress1.value = 0
  clearInterval(progressInterval1)
})
}

const loadSectionData = async () => {
  progress2.value = 1
  progressInterval2 = setInterval(() => {
    progress2.value += 1
    if (progress2.value >= 100) progress2.value = 0
  }, 100)
  await api.get('/section/all').then(sectionList => {
        secrows.value = sectionList.data.map((item, i) => ({ ...item, Sno: i + 1, record:'section' }))
        store.commit('setSections', sectionList.data)
        progress2.value = 0
        clearInterval(progressInterval2)
  })
}
const handleEdit = (row) => {
  if(row.record == 'cls') {
    Obj.value = { ...row }
  } else {
    secObj.value = {...row}
  }
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const save = async () => {
  const fields = {
    Name: { value: Obj.value.name, validators: [isRequired], },
    Section: { value: Obj.value.section, validators: [isRequired], },
  };
  error1.value = validateForm(fields);
const idx = rows.value.findIndex(item => item.name.toLowerCase() === Obj.value.name.toLowerCase() && item.section.toLowerCase() === Obj.value.section.toLowerCase() && item._id !== Obj.value._id);
if (idx >= 0) {
   msgObj.value = { msg: "Class Name already exists.", role: "danger", show: true, };
  return ;
}
  if (Object.keys(error1.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/cls${url}`, Obj.value)
      .then(() => {
        loadClassData();
        reset();
        msgObj.value = { msg: `Class ${msg} Successfuly`, role: "success", show: true, };
      })
      .catch((error) => { console.log(error); });
  }
}
const secSave = async () => {
  const fields = {
    Name: { value: secObj.value.Name, validators: [isRequired], },
  };
  const idx = secrows.value.findIndex(item => item.Name.toLowerCase() === secObj.value.Name.toLowerCase() && item._id !== secObj.value._id);
if (idx >= 0) {
   msgObj.value = { msg: "Section already exists.", role: "danger", show: true, };
  return ;
}
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(secObj.value);
    await api[method](`/section${url}`, secObj.value)
      .then((response) => {
        loadSectionData();
        secreset();
        msgObj.value = { msg: `Section ${msg} Successfuly`, role: "success", show: true, };
        console.log(response);
      })
      .catch((error) => { console.log(error); });
  }
}
const reset = () => {
  Obj.value = { name: "", section: "" };
  msgObj.value = { msg: "", role: "", show: false };
  error1.value = {};
}
const secreset = () => {
  secObj.value = { Name: "" };
  msgObj.value = { msg: "", role: "", show: false };
  errors.value = {};
}

const delRecord = async () => {
  const delName = delObj.value.record;
  await api.delete(`/${delObj.value.record}/${delObj.value._id}`)
    .then(() => {
      if(delName == 'section') {
          loadSectionData();
           msgObj.value = { msg: `Section Deleted Successfuly.`, role: "danger", show: true, };
      }else {
        loadClassData();
         msgObj.value = { msg: `Class Deleted Successfuly.`, role: "danger", show: true, };
      }
      delObj.value={};
    });
}
onMounted(() => {
  loadClassData()
  loadSectionData()
})
</script>
<style scoped>
.stuImage {
  width: 50px;
}
.no-underline {
  text-decoration: none;
}
table tbody>tr {
  height: 0px;
}
.table>:not(caption)>*>* {
  padding: 5px 5px;
}
</style>
